module.exports = __webpack_public_path__ + "static/media/6625.4e5a9b46.jpg";